export { default } from './Footer';



// WEBPACK FOOTER //
// ./src/components/molecules/Footer/index.js